<template>
  <b-form-input
    ref="input"
    :class="`dn-form-input-component ${classes}`"
    :value="value"
    :state="ValidationState"
    :placeholder="placeHolder"
    @blur="inputHasBeenVisited = true"
    @input="UpdateValue"
  />
</template>

<script>
  export default {
    props: {
      classes: {
        type: String,
        default: "form-control"
      },
      required:{
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: ""
      },
      placeHolder: {
        type: String,
        default: ""
      }
    },
    data: () => ({
      inputHasBeenVisited: false,
      inputValue: null
    }),
    computed: {

      ValidationState(){

        //If this returns true:      the input is colored green
        //If this returns false:     the input is colored red
        //If this this returns null: the input is colored grey

        //If it is not required, then it is valid
        if(!this.required){
          return true;
        }

        //If it is required, but has not been visited, then it is neither valid nor invalid
        if(!this.inputHasBeenVisited){
          return null;
        }
        //If it is required, and has been visited, and has a value, then it is valid
        if(this.inputValue){
          return true;
        }
        return false;
      },
      allClasses(){
        var allClasses = "";
        if(this.required){
          allClasses += "dn-form-input-component--required";
        }
        return allClasses;
      }
    },
    created() {
      this.inputValue = this.value;
    },

    methods: {
      UpdateValue(){
        this.inputValue = this.$refs.input.localValue
        this.$emit("input", this.inputValue);
      }
    }
  }
</script>
